import { render, staticRenderFns } from "./pageRecord.vue?vue&type=template&id=bd742ad2&scoped=true&"
import script from "./pageRecord.vue?vue&type=script&lang=js&"
export * from "./pageRecord.vue?vue&type=script&lang=js&"
import style0 from "./pageRecord.vue?vue&type=style&index=0&id=bd742ad2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd742ad2",
  null
  
)

export default component.exports